module.exports = __webpack_public_path__ + "static/img/drisa.dd73086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/drisa.png
// module id = 481
// module chunks = 1